import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: "pme-hero",
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeroComponent implements OnInit {
  @Input() size: string;
  @Input() type: string;
  @Input() title: string;
  @Input() showButton: boolean;
  @Input() buttonName: string;
  @Input() redirectURL: string;

  constructor(
    private matIconRegistry: MatIconRegistry, 
    private domSanitizer: DomSanitizer
    ) {
      this.matIconRegistry.addSvgIcon('new-error', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/images/new-dialog-icons/new-error.svg'));
      this.matIconRegistry.addSvgIcon('new-success', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/images/new-dialog-icons/new-success.svg'));
      this.matIconRegistry.addSvgIcon('new-warn', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/images/new-dialog-icons/new-warn.svg'));
  }


  ngOnInit(): void {
    if (!this.redirectURL) {
      this.redirectURL = environment.serasaHomePage;
    }
  }
}

